import { getClientProfile } from '@/services/Users';
import { useQuery } from '@tanstack/react-query';
import { AccountManagerType } from '@/features/support/support-panel/support-panel-home/support-panel-home-areas/account-manager/type';

export const useClientProfile = () => {
  const { data: clientProfile, isLoading } = useQuery<{
    accountManager: AccountManagerType
  }>({
    queryKey: ['clientProfile'],
    queryFn: getClientProfile as any,

  });

  return { clientProfile, isLoading };
};
